var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadModules } from "esri-loader";
import store, { STATES_MAIN, STATES_START, STATES_FIRST_VISIT } from "../../state";
import { MapLayers } from "../../services";
import { writable } from "svelte/store";
import CancelablePromise from "cancelable-promise";
const initialState = {
    isSearchDisabled: true,
    searchPromise: undefined
};
export default class LocationSearch {
    constructor() {
        this.mapViewSvc = undefined;
        this.isLoadingEsri = false;
        this.searchViewModel = undefined;
        this.boundaryLayer = undefined;
        this.searchPromise = undefined;
        this.store = writable(initialState);
        const unsubscribe = store.subscribe((state) => __awaiter(this, void 0, void 0, function* () {
            this.mapViewSvc = state.mapViewService;
            const isMapLoaded = this.mapViewSvc && this.mapViewSvc.isReady();
            if (isMapLoaded && !this.isLoadingEsri) {
                try {
                    this.isLoadingEsri = true;
                    yield this.loadEsri();
                    this.store.update(state => {
                        state.isSearchDisabled = false;
                        return state;
                    });
                    unsubscribe();
                }
                catch (e) {
                    console.error(e);
                }
            }
        }));
    }
    loadEsri() {
        return __awaiter(this, void 0, void 0, function* () {
            const [SearchViewModel, LayerSearchSource] = yield loadModules([
                "esri/widgets/Search/SearchViewModel",
                "esri/widgets/Search/LayerSearchSource"
            ]);
            const ready = this.mapViewSvc && this.mapViewSvc.isReady();
            if (ready) {
                try {
                    // @ts-ignore: mapViewSvc is ready & defined
                    this.boundaryLayer = (yield this.mapViewSvc.findLayer(MapLayers.BOUNDARY));
                    this.searchViewModel = new SearchViewModel({
                        includeDefaultSources: false,
                        sources: [
                            new LayerSearchSource({
                                displayField: "Suburb",
                                searchFields: ["Suburb", "Postcode"],
                                outFields: ["*"],
                                name: "Suburb",
                                layer: this.boundaryLayer,
                                maxSuggestions: 3,
                                maxResults: 3
                            })
                        ]
                    });
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }
    suggestLocation(otherSearchString) {
        return new CancelablePromise((resolve, reject) => {
            let suburbToSearch = otherSearchString;
            if (this.searchViewModel && suburbToSearch) {
                const source = this.searchViewModel.sources.getItemAt(0);
                source.filter = {
                    where: `Suburb LIKE '${suburbToSearch}%'`
                };
                this.searchViewModel
                    .search(suburbToSearch)
                    .then(response => {
                    const filteredResponse = response.results
                        .map(r => {
                        return {
                            name: r.source.name,
                            results: r.results
                        };
                    })
                        .reduce((prev, r) => {
                        const results = r.results.map((i) => {
                            i.groupLabel = r.name;
                            return i;
                        });
                        prev = [...prev, ...results];
                        return prev;
                    }, []);
                    return resolve(filteredResponse || []);
                })
                    .catch(e => {
                    reject(e);
                });
            }
        });
    }
    updateSearchPromise() {
        this.store.update(state => {
            state.searchPromise = this.searchPromise;
            return state;
        });
    }
    handleSearch(searchString) {
        if (this.searchPromise) {
            this.searchPromise.cancel();
            this.updateSearchPromise();
        }
        if (searchString) {
            this.searchPromise = this.suggestLocation(searchString);
            this.updateSearchPromise();
            this.searchPromise
                .then((suggestions) => {
                store.update(state => {
                    state.searchResults = suggestions.filter((s) => s.groupLabel !== "World");
                    return state;
                });
            })
                .catch((e) => {
                console.error(e);
            });
        }
        else {
            this.searchPromise = undefined;
            this.updateSearchPromise();
            store.update(state => {
                state.searchResults = [];
                return state;
            });
        }
    }
    goTo(suggestion) {
        store.update(state => {
            state.searchResults = [];
            state.selectedLocation = suggestion.feature;
            return state;
        });
        if (this.mapViewSvc && this.boundaryLayer && this.mapViewSvc.isReady()) {
            this.searchPromise = undefined;
            this.updateSearchPromise();
        }
    }
    clearSearch() {
        var _a;
        if (this.searchPromise) {
            this.searchPromise.cancel();
        }
        this.searchPromise = undefined;
        this.updateSearchPromise();
        (_a = this.mapViewSvc) === null || _a === void 0 ? void 0 : _a.unfocusFeature();
        store.update(state => {
            state.searchResults = [];
            state.riskProfile = undefined;
            state.selectedLocation = undefined;
            return state;
        });
    }
    handleEnableSearch(isFtus) {
        store.update(state => {
            state.currentState = isFtus
                ? `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.SEARCHING}`
                : `${STATES_MAIN.START}.${STATES_START.SEARCHING}`;
            return state;
        });
    }
    handleDisableSearch(isFtus) {
        store.update(state => {
            state.currentState = isFtus
                ? `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.SEARCH}`
                : `${STATES_MAIN.START}.${STATES_START.DEFAULT}`;
            return state;
        });
    }
}
